// extracted by mini-css-extract-plugin
module.exports = {"screen-xs":"480px","screen-sm":"576px","screen-md":"768px","screen-lg":"992px","screen-xl":"1200px","screen-xxl":"1600px"};